<template>
  <svg
    fill="none"
    height="394"
    viewBox="0 0 362 394"
    width="362"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      fill="#F8FAFB"
      height="80"
      opacity="0.06"
      rx="8"
      transform="rotate(180 248 405)"
      width="80"
      x="248"
      y="405"
    />
    <rect
      fill="url(#paint0_linear_107_9056)"
      height="80"
      opacity="0.03"
      rx="8"
      transform="rotate(180 164 153)"
      width="80"
      x="164"
      y="153"
    />
    <rect
      fill="url(#paint1_linear_107_9056)"
      height="80"
      opacity="0.06"
      rx="8"
      transform="rotate(180 80 69)"
      width="80"
      x="80"
      y="69"
    />
    <rect
      fill="url(#paint2_linear_107_9056)"
      height="80"
      opacity="0.04"
      rx="8"
      transform="rotate(180 164 405)"
      width="80"
      x="164"
      y="405"
    />
    <rect
      fill="#F3F5F7"
      height="80"
      opacity="0.06"
      rx="8"
      transform="rotate(180 164 69)"
      width="80"
      x="164"
      y="69"
    />
    <rect
      fill="url(#paint3_linear_107_9056)"
      height="80"
      opacity="0.04"
      rx="8"
      transform="rotate(180 164 321)"
      width="80"
      x="164"
      y="321"
    />
    <rect
      fill="#F8FAFB"
      height="80"
      opacity="0.12"
      rx="8"
      transform="rotate(180 248 321)"
      width="80"
      x="248"
      y="321"
    />
    <rect
      fill="#F8FAFB"
      height="80"
      opacity="0.04"
      rx="8"
      transform="rotate(180 248 237)"
      width="80"
      x="248"
      y="237"
    />
    <rect
      fill="#F8FAFB"
      height="80"
      opacity="0.02"
      rx="8"
      transform="rotate(180 248 153)"
      width="80"
      x="248"
      y="153"
    />
    <rect
      fill="#F8FAFB"
      height="80"
      opacity="0.12"
      rx="8"
      transform="rotate(180 248 69)"
      width="80"
      x="248"
      y="69"
    />
    <rect
      fill="#F8F8FA"
      height="80"
      opacity="0.02"
      rx="8"
      transform="rotate(180 332 405)"
      width="80"
      x="332"
      y="405"
    />
    <rect
      fill="#F6F8FA"
      height="80"
      opacity="0.06"
      rx="8"
      transform="rotate(180 332 321)"
      width="80"
      x="332"
      y="321"
    />
    <rect
      fill="#F6F8FA"
      height="80"
      opacity="0.12"
      rx="8"
      transform="rotate(180 332 153)"
      width="80"
      x="332"
      y="153"
    />
    <rect
      fill="#F8FAFB"
      height="80"
      opacity="0.02"
      rx="8"
      transform="rotate(180 332 69)"
      width="80"
      x="332"
      y="69"
    />
    <rect
      fill="#F6F8FA"
      height="80"
      opacity="0.12"
      rx="8"
      transform="rotate(180 416 405)"
      width="80"
      x="416"
      y="405"
    />
    <rect
      fill="#F6F8FA"
      height="80"
      opacity="0.12"
      rx="8"
      transform="rotate(180 416 321)"
      width="80"
      x="416"
      y="321"
    />
    <rect
      fill="#F3F5F7"
      height="80"
      opacity="0.06"
      rx="8"
      transform="rotate(180 416 237)"
      width="80"
      x="416"
      y="237"
    />
    <rect
      fill="url(#paint4_linear_107_9056)"
      height="80"
      opacity="0.02"
      rx="8"
      transform="rotate(180 164 237)"
      width="80"
      x="164"
      y="237"
    />
    <rect
      fill="#F6F8FA"
      height="80"
      opacity="0.08"
      rx="8"
      transform="rotate(180 416 153)"
      width="80"
      x="416"
      y="153"
    />
    <rect
      fill="#F6F8FA"
      height="80"
      opacity="0.06"
      rx="8"
      transform="rotate(180 416 69)"
      width="80"
      x="416"
      y="69"
    />
    <rect
      fill="#EBEDF5"
      height="80"
      opacity="0.12"
      rx="40"
      transform="rotate(180 332 237)"
      width="80"
      x="332"
      y="237"
    />
    <path
      d="M292 189.254L301.451 195.417L292 181.859L282.767 195.425L292 189.254Z"
      fill="white"
    />
    <path
      d="M301.539 196.995L292 191.005L282.461 197L292 202.995L301.539 196.995Z"
      fill="white"
    />
    <path
      d="M282.549 198.575L292 212.14L301.233 198.572L292 204.745L282.549 198.575Z"
      fill="white"
    />
    <defs>
      <linearGradient
        id="paint0_linear_107_9056"
        gradientUnits="userSpaceOnUse"
        x1="164"
        x2="244"
        y1="194.5"
        y2="195"
      >
        <stop stop-color="#F8FAFB" />
        <stop
          offset="1"
          stop-color="#F8FAFB"
          stop-opacity="0"
        />
      </linearGradient>
      <linearGradient
        id="paint1_linear_107_9056"
        gradientUnits="userSpaceOnUse"
        x1="80"
        x2="160"
        y1="110.5"
        y2="111"
      >
        <stop stop-color="#F8FAFB" />
        <stop
          offset="1"
          stop-color="#F8FAFB"
          stop-opacity="0"
        />
      </linearGradient>
      <linearGradient
        id="paint2_linear_107_9056"
        gradientUnits="userSpaceOnUse"
        x1="164"
        x2="244"
        y1="446.5"
        y2="447"
      >
        <stop stop-color="#F8FAFB" />
        <stop
          offset="1"
          stop-color="#F8FAFB"
          stop-opacity="0"
        />
      </linearGradient>
      <linearGradient
        id="paint3_linear_107_9056"
        gradientUnits="userSpaceOnUse"
        x1="164"
        x2="244"
        y1="362.5"
        y2="363"
      >
        <stop stop-color="#F8FAFB" />
        <stop
          offset="1"
          stop-color="#F8FAFB"
          stop-opacity="0"
        />
      </linearGradient>
      <linearGradient
        id="paint4_linear_107_9056"
        gradientUnits="userSpaceOnUse"
        x1="164"
        x2="244"
        y1="278.5"
        y2="279"
      >
        <stop stop-color="#F8FAFB" />
        <stop
          offset="1"
          stop-color="#F8FAFB"
          stop-opacity="0"
        />
      </linearGradient>
    </defs>
  </svg>
</template>

<script>
export default {
  name: 'NlpCheckAddressBackground2',
}
</script>